module.exports = __webpack_public_path__ + "static/img/cyndia.650908f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/cyndia.jpg
// module id = 206
// module chunks = 1